import type { FC } from 'react';
import { Flex, Section, Typography } from '@ui';
import { useTranslation } from 'react-i18next';
import { clientOnly } from 'vike-react/clientOnly';
import { ActiveAtcTable } from '@/components/ActiveAtcTable/ActiveAtcTable';
import styles from './ControllersMapSection.module.css';

const VatsimRadar = clientOnly(() => import('../../../../components/VatsimRadar/VatsimRadar').then(r => r.VatsimRadar));

export const ControllersMapSection: FC = () => {
    const { t } = useTranslation();

    return (
        <Flex className={styles.container} gap={80}>
            <Flex flex="0 0 calc(40% - 40px)" className={styles.controllersContainer}>
                <Section variant="filled" size="l" block>
                    <Flex vertical gap={40} className={styles.activeAtcWrapper}>
                        <Typography.Heading level={3} color="textPrimary">
                            {t('ATC_Title')}
                        </Typography.Heading>
                        <ActiveAtcTable />
                    </Flex>
                </Section>
            </Flex>
            <Flex flex="0 0 calc(60% - 40px)">
                <Section size="l" noPadding block>
                    <VatsimRadar />
                </Section>
            </Flex>
        </Flex>
    );
};
